import { api } from "lib/api";
import Footer from "shared/Footer";
import Meta from "shared/Meta";
import Nav from "shared/Nav";
import { useForm } from "react-hook-form";
import axios from "axios";
import ReCAPTCHA from "react-google-recaptcha";
import { useRef } from "react";
import { useState } from "react";

export default function ContactPage({ settings }) {
  const [message, setMessage] = useState(null);
  const recaptchaRef = useRef(null);
  const {
    register,
    handleSubmit,
    formState: { isSubmitting },
  } = useForm();
  const handleSubmitForm = (values) => {
    const { current: recaptcha }: { current: any } = recaptchaRef;
    recaptcha
      .execute()
      .then((token) => {
        axios
          .post(`/api/contact`, { ...values, token })
          .then(({ data }) => setMessage("Successfully sent message."))
          .catch((err) => setMessage("Something went wrong please try again later."));
      })
      .catch((err) => setMessage("Something went wrong please try again later."));
  };
  return (
    <>
      <Meta settings={settings} />
      <Nav settings={settings} />
      <div className="container mx-auto px-4">
        <h1 className="font-black text-blue-900 text-6xl my-4">Contact</h1>
        <hr className="text-gray-300" />
        <div className="min-h-[500px] my-8">
          <div className="bg-gradient-to-r md:flex">
            <div className="md:w-1/3">
              <div className="text-gray-700 font-medium">The Speckled Truth</div>
            </div>
            <div className="md:w-2/3">
              <div
                className={`p-2 rounded shadow-2xl border bg-gray-200 text-gray-600 font-medium ${
                  message ? "opacity-1" : "opacity-0"
                }`}
              >
                {message}
              </div>
              <form onSubmit={handleSubmit(handleSubmitForm)}>
                <ReCAPTCHA
                  sitekey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}
                  size="invisible"
                  ref={recaptchaRef}
                />
                <label htmlFor="id_name" className="text-gray-600 mr-2 font-medium uppercase">
                  Name:{" "}
                </label>
                <input
                  {...register("name", { required: true })}
                  id="id_name"
                  className="border shadow-xl rounded w-full mb-2 p-2"
                />
                <label htmlFor="id_name" className="text-gray-600 mr-2 font-medium uppercase">
                  Email:{" "}
                </label>
                <input
                  {...register("email", { required: true })}
                  className="border shadow-xl rounded w-full mb-2 p-2"
                />
                <label htmlFor="id_name" className="text-gray-600 mr-2 font-medium uppercase">
                  Message:{" "}
                </label>
                <textarea
                  {...register("message", { required: true })}
                  className="border shadow-xl rounded w-full p-2"
                />
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="flex items-center justify-center w-full bg-gradient-to-tr px-3 py-4 rounded shadow-xl from-blue-500 to-blue-900 text-gray-200 hover:text-white uppercase font-medium"
                >
                  <span className="mr-2 ">Submit</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4"
                    />
                  </svg>
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
      <Footer settings={settings} />
    </>
  );
}

export async function getServerSideProps() {
  const settings = await api.getSettings();

  return {
    props: {
      settings,
    },
  };
}
